import api from "./api";

const receiptService = {
  list: (params) => api.get("/receipts", { params }),
  get: (id) => api.get(`/receipts/${id}`),
  getAudit: (id) => api.get(`/receipts/${id}/audit`),
  create: (data) => api.post("/receipts", data),
  update: (id, data) => api.put(`/receipts/${id}`, data),
  submit: (id) => api.post(`/receipts/${id}/submit`),
  reverse: (id, data) => api.post(`/receipts/${id}/reverse`, data),
  allocate: (id, data) => api.post(`/receipts/${id}/allocate`, data),
  delete: (id) => api.delete(`/receipts/${id}`),
};

export default receiptService;
